import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useState } from 'react';
import { useTranslation } from '@crehana/i18n';
import { Dropdown, DropdownContent, DropdownFilterButton, DropdownIconsList } from "../Dropdown";
import { PopperAnchor } from "../Popper";
import locales from "./i18n";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var SelectorGenerator = function SelectorGenerator(_ref) {
  var optionsSelector = _ref.optionsSelector;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    category = _useState2[0],
    setCategory = _useState2[1];
  var _useTranslation = useTranslation(),
    languageCode = _useTranslation.languageCode;
  var t = locales[languageCode];
  var handleSelectCategory = function handleSelectCategory(categoryValue) {
    setCategory(categoryValue);
  };
  return /*#__PURE__*/_jsx(PopperAnchor, {
    children: /*#__PURE__*/_jsx(Dropdown, {
      children: /*#__PURE__*/_jsxs("div", {
        className: "tw-w-full",
        children: [/*#__PURE__*/_jsx("div", {
          className: "tw-flex tw-items-center tw-justify-center",
          children: /*#__PURE__*/_jsx(DropdownFilterButton, {
            children: t.FILTERS_BUTTON_DROPDOWN
          })
        }), /*#__PURE__*/_jsx(DropdownContent, {
          children: /*#__PURE__*/_jsx(DropdownIconsList, {
            className: "tw-h-full !tw-max-h-full tw-max-w-[400px]",
            contentClassName: "tw-line-clamp-none",
            items: optionsSelector,
            onSelect: handleSelectCategory
          })
        })]
      })
    })
  });
};